<template>
  <div>
    <v-card class="mx-3 mt-1">
      <v-card-text class="pa-0">
        <base-data-grid
          :ref="grid.key"
          :gridKey="grid.key"
          :dataSource="grid.dataSource"
          :columns="grid.columns"
          :exportFileName="title"
          @on-add-click="add"
          :allowGrouping="false"
          :allowFilterPanel="false"
          :title="title"
        >
          <template slot="columnTemplates" slot-scope="row">
            <div v-if="row.data.field == 'AccountType'">
              <span>{{ getAccountType(row.data.item) }}</span>
            </div>
          </template>

          <template slot="customActionTemplates" slot-scope="row">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <a
                  v-on="on"
                  @click.prevent="activate(row.data.item)"
                  class="px-2"
                >
                  <v-icon :color="row.data.item.IsActivated ? 'green' : 'red'"
                    >mdi-account</v-icon
                  >
                </a>
              </template>
              <span>
                {{
                  row.data.item.IsActivated ? $t("Deactivate") : $t("Activate")
                }}
              </span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <a
                  v-on="on"
                  @click.prevent="editItem(row.data.item)"
                  class="px-2"
                >
                  <v-icon color="primary">mdi-pencil</v-icon>
                </a>
              </template>
              <span>{{ $t("Edit") }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <a
                  v-on="on"
                  @click.prevent="deleteItem(row.data.item)"
                  class="px-2"
                >
                  <v-icon color="red">mdi-delete</v-icon>
                </a>
              </template>
              <span>{{ $t("Delete") }}</span>
            </v-tooltip>
          </template>
          <template v-slot:action-buttons>
            <v-btn small color="primary" @click.prevent="onImport">
              {{ $t("Import") }}
              <v-icon>mdi-application-import</v-icon>
            </v-btn>
          </template>
        </base-data-grid>
      </v-card-text>
    </v-card>

    <UserModal
      :ref="modalKey"
      :allowAccountTypeEdit="true"
      @on-item-saved="onItemSaved"
    />
    <UserImportModal :ref="importModalKey" @on-imported="onItemSaved" />
  </div>
</template>

<script>
import UserService from '@/services/UserService';
import UserModal from '@/components/administration/user/UserModal.vue';
import UserImportModal from '@/components/administration/user/UserImportModal.vue';
import Utils from '@/ecm/common/Utils';
import AccountType from '@/ecm/variables/AccountType';

export default {
    components: {
        UserModal,
        UserImportModal,
    },
    data() {
        return {
            title: this.$t('Users'),
            grid: {
                key: 'userGrid',
                dataSource: UserService.getGrid(),
                columns: [
                    {
                        field: 'Login',
                        caption: this.$t('Login'),
                        type: 'string',
                    },
                    {
                        field: 'Name',
                        caption: this.$t('FirstName'),
                        type: 'string',
                    },
                    {
                        field: 'Surname',
                        caption: this.$t('Surname'),
                        type: 'string',
                    },
                    {
                        field: 'Email',
                        caption: this.$t('Email'),
                        type: 'string',
                    },
                    {
                        field: 'AccountType',
                        caption: this.$t('AccountType'),
                        type: 'string',
                        hasTemplate: true,
                    },
                ],
            },
            modalKey: 'modalUser',
            importModalKey: 'importModalKey',
        };
    },
    computed: {
        modalInstance() {
            return this.$refs[this.modalKey];
        },
        importModalInstance() {
            return this.$refs[this.importModalKey];
        },
        gridInstance() {
            return this.$refs[this.grid.key];
        },
    },
    methods: {
        editItem(dto) {
            this.modalInstance.editUserFromGrid(dto.Id);
        },
        deleteItem(dto) {
            this.$confirm(this.$t('ItemDeleteConfirmation') + '.' + this.$t('Site.UserConfig.LoginDeleted'), {
                title: this.$t('Delete'),
                icon: 'mdi-alert',
                color: 'red',
                buttonTrueText: this.$t('Delete'),
                buttonFalseText: this.$t('Cancel'),
            }).then((res) => {
                if (res == 1) {
                    UserService.delete(dto.Id).then(() => {
                        this.gridInstance.refresh();
                        Utils.toast.success(
                            this.$t('User') + ' ' + this.$t('DeletedSuccessfully')
                        );
                    });
                }
            });
        },
        activate(user) {
            UserService.activate(user.Id).then((result) => {
                if (result) {
                    this.gridInstance.refresh();
                    if (user.IsActivated) {
                        Utils.toast.success(
                            this.$t('User') + ' ' + this.$t('DeactivatedSuccessfully')
                        );
                    } else {
                        Utils.toast.success(
                            this.$t('User') + ' ' + this.$t('ActivatedSuccessfully')
                        );
                    }
                }
            });
        },
        add() {
            this.modalInstance.new();
        },
        onImport() {
            this.importModalInstance.new();
        },
        onItemSaved() {
            this.gridInstance.refresh();
        },
        getAccountType(data) {
            switch (data.AccountType) {
            case AccountType.FullAccess:
                return this.$t('FullAccessUsers');
            case AccountType.Concurrent:
                return this.$t('ConcurrentUsers');
            case AccountType.Readonly:
                return this.$t('ReadonlyUsers');
            default:
                return '';
            }
        },
    },
};
</script>
